import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { FormikFormGroup, TimeUnitInput } from "components/common";
import { useValidateDataAdapter } from "components/lookup-tables/hooks/useLookupTablesAPI";
import AdapterConfigFormFields from "./AdapterConfigFormFields";
function AdapterFormFields() {
  const { t } = useTranslation("lookup_tables");
  const { errors, values, touched, setFieldValue, setValues, setErrors } = useFormikContext();
  const { validateDataAdapter } = useValidateDataAdapter();
  const configRef = useRef(null);
  const [generateName, setGenerateName] = useState(!values.title);
  const _sanitizeName = (inName) => inName.trim().replace(/\W+/g, "-").toLocaleLowerCase();
  const _runValidations = useCallback(() => {
    validateDataAdapter(values).then((resp) => {
      var _a, _b;
      const auxErrors = Object.fromEntries(
        Object.keys(resp.errors).map((key) => [key, errors[key] || resp.errors[key][0]])
      );
      const configErrors = ((_b = (_a = configRef == null ? void 0 : configRef.current) == null ? void 0 : _a.validate) == null ? void 0 : _b.call(_a)) || {};
      setErrors({ ...auxErrors, ...configErrors });
    });
  }, [validateDataAdapter, values, setErrors, errors]);
  const handleTitleChange = (event) => {
    if (!generateName) return;
    const safeName = _sanitizeName(event.target.value);
    setValues({
      ...values,
      title: event.target.value,
      name: safeName
    });
  };
  useEffect(() => _runValidations(), [_runValidations, values]);
  const updateCustomErrorTTL = (value, unit, enabled) => {
    setFieldValue("custom_error_ttl", value);
    setFieldValue("custom_error_ttl_unit", unit);
    setFieldValue("custom_error_ttl_enabled", enabled);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "title",
      label: t("adapter_form.title_label"),
      required: true,
      onChange: handleTitleChange,
      help: touched.title && errors.title ? null : t("adapter_form.title_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "description",
      label: t("shared.description"),
      help: t("adapter_form.description_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "name",
      label: t("adapter_form.name_label"),
      required: true,
      error: touched.name && errors.name ? errors.name : null,
      onChange: () => setGenerateName(!touched.name),
      help: touched.name && errors.name ? null : t("adapter_form.name_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: t("adapter_form.error_ttl_label"),
      help: t("adapter_form.error_ttl_help"),
      update: updateCustomErrorTTL,
      value: values.custom_error_ttl,
      unit: values.custom_error_ttl_unit || "MINUTES",
      units: ["MILLISECONDS", "SECONDS", "MINUTES", "HOURS", "DAYS"],
      enabled: values.custom_error_ttl_enabled,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(AdapterConfigFormFields, { ref: configRef, validationErrors: errors }));
}
export default AdapterFormFields;
